export const API_ABSENCES_YEARLY_SUMMARY = 'api/v1/absences/yearly-summary';
// Dimensione massima file upload (3MB)
export const MAX_FILE_SIZE = 3 * 1024 * 1024;
const TRIPS = 'trips';
const KILOMETERS = 'kilometers';
const EXPENSES = 'expenses';
const ADMINISTRATION = 'administration';
export const DATE_NEW_EXPENSES_TYPE = new Date('2025-02-01T00:00:00');
export const ROUTES = {
  LOGIN: '/login',
  PROFILE: '/profile',
  WORKLOG: '/tempo',
  BUDGET: '/budget',
  ADMINISTRATION: `/${ADMINISTRATION}`,
  ADMIN_BUDGET: '/administration/budget',
  PERMISSIONS_MATRIX: '/administration/permissions',
  REPORT: '/report',
  TRIPS,
  KILOMETERS,
  EXPENSES,
  TRIPS_KILOMETERS: `/${TRIPS}/${KILOMETERS}`,
  TRIPS_EXPENSES: `/${TRIPS}/${EXPENSES}`,
  ABSENCES: '/absences',
  VIEW_ABSENCES: '/view-absences',
  CERTIFICATIONS: '/certifications',
  EARNED_CERTIFICATIONS: '/earned-certifications',
  RETROSPECTIVE_GOAL_TYPES: '/retrospective-goal-types',
  RETROSPECTIVE_GOALS: '/retrospective-goals',
  RETROSPECTIVE: '/retrospectives',
  PROJECTS: '/projects',
};

export const AUTH_CLIENTS = {
  i3portalBackend: 'i3portal-backend',
};

export const API = {
  TOKEN: '/oauth2/token/',
  REVOKE_TOKEN: '/oauth2/revoke_token/',
  USERS_SEND_MAIL: 'api/v1/users/sendemail',
  CURRENT_USER: 'api/v1/users/current',
  USER_LIST: 'api/v1/users/list',
  SIGNATURE: 'api/v1/users/current/signature',
  AVATAR: 'api/v1/users/current/avatar',
  USER_AVATAR: 'api/v1/users/avatar',
  TRIPS: 'api/v1/trips/',
  REPORTS: 'api/v1/reports/',
  REPORTS_PDF: 'api/v1/reports/pdf/',
  REPORTS_XLSX: 'api/v1/reports/xlsx/',
  REPORTS_CONFIRM: 'api/v1/reports/confirm/',
  REPORTS_DETAIL: 'api/v1/reports/detail/',
  REPORTS_LIST: 'api/v1/users/list/report',
  REPORTS_WORKLOGS_PREVIEW: 'api/v1/worklogs/json/report',
  REPORTS_ABSENCES_DISC: 'api/v1/absences/disc-report',
  REPORTS_ATTENDANCE_SHEET: 'api/v1/worklogs/attendance-sheet/',
  REPORTS_TICKET_RESTAURANT: 'api/v1/worklogs/ticket-report/',
  SYSTEM: 'api/v1/system',
  SYSTEM_BUDGETS: 'api/v1/budgets/',
  SYSTEM_VERSION: 'api/v1/version/',
  EXPENSES: 'api/v1/expenses/',
  EXPENSES_NOT_TRIP: 'api/v1/expenses-not-trip/',
  EXPENSES_BY_TYPE: 'api/v1/expenses-by-type/',
  EXPENSES_BY_TYPE_ADMIN: 'api/v1/expenses-by-type/administration',
  TRAINING_DAYS: 'api/v1/trainingDay/',
  TRAINING_EXPENSES: 'api/v1/trainingBudget/',
  TRAINING_DAYS_ADMIN: 'api/v1/trainingDay/administration/',
  TRAINING_EXPENSES_ADMIN: 'api/v1/trainingBudget/administration/',
  UTILITIES: 'api/v1/utilities/',
  CALENDAR: 'api/v1/calendar/',
  ABSENCES: 'api/v1/absences/',
  WORKLOGS: 'api/v1/worklogs/',
  WORKLOGS_ISSUE_HOURS_SUMMARY: 'api/v1/worklogs/issue-hours-summary/',
  LUNCHES: 'api/v1/lunches/',
  MULTIPLE_WORKLOGS: 'api/v1/worklogs/multiple/',
  ISSUES: 'api/v1/issues/',
  ISSUES_ALL: 'api/v1/issues/all/',
  PROJECT_ISSUES: 'api/v1/project-issues/',
  PROJECTS: 'api/v1/projects/',
  PROJECTS_ALL: 'api/v1/projects/all/',
  PROJECTS_NOT_INTERNAL: 'api/v1/projects-not-internal/',
  ME_ISSUES: 'api/v1/me/issues/',
  ME_PROJECTS: 'api/v1/me/projects/',
  CERTIFICATIONS: 'api/v1/certifications/',
  CERTIFICATIONS_EMITTERS: 'api/v1/certifications/emitters/',
  CERTIFICATIONS_CATEGORIES: 'api/v1/certifications/categories/',
  EARNED_CERTIFICATIONS: 'api/v1/earned-certifications/',
  RETROSPECTIVE_GOAL_TYPES: 'api/v1/retrospective-goal-types/',
  RETROSPECTIVE_GOALS: 'api/v1/retrospective-goals/',
  RETROSPECTIVE: 'api/v1/retrospective/',
  USERS: 'api/v1/users/',
  COMPANIES: 'api/v1/companies/',
  USER_RETROSPECTIVE: 'api/v1/users/retrospective',
  ABSENCES_YEARLY_SUMMARY: 'api/v1/absences/yearly-summary',
};

export const EXPENSE_BONUS_SMART_WORKING = 'bonus_smart_working';
export const EXPENSE_BONUS_BOOKS = 'bonus_books';
const EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE_OLD = {
  highway_parking: true,
  room_and_board: true,
  travel: true,
  entertainment_expense: true,
  it_equipment: true,
  consumable: true,
  training_expenses: true,
  [EXPENSE_BONUS_SMART_WORKING]: false,
  [EXPENSE_BONUS_BOOKS]: false,
  other: true,
  cash_advance: false,
};

const EXPENSE_TYPE_KM = {
  customers: true,
  training: true,
  training_budget: true,
  corporate_events: true,
  marketing_presale: true,
  other_new: true,
};

export const EXPENSE_SMART_WORKING = 'bonus_smart_working';
export const EXPENSE_BOOKS_BUDGET = 'books_budget';

const EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE = {
  ...EXPENSE_TYPE_KM,
  [EXPENSE_BOOKS_BUDGET]: false,
  [EXPENSE_SMART_WORKING]: false,
  advance: false,
};

export const EXPENSES_TYPES = Object.keys(
  EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE
);
export const EXPENSES_TYPES_OLD = Object.keys(
  EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE_OLD
);
export const EXPENSES_TYPES_KM = Object.keys(EXPENSE_TYPE_KM);

export const canHaveCompanyInvoice = (expenseType) =>
  Object.keys(EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE).includes(expenseType)
    ? EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE[expenseType]
    : EXPENSE_TYPE_CAN_HAVE_COMPANY_INVOICE_OLD[expenseType];

export const PERMISSIONS = {
  TRIPS_KILOMETERS_VIEW: 'trips.kilometers.view',
  TRIPS_KILOMETERS_EDIT: 'trips.kilometers.edit',
  TRIPS_KILOMETERS_USER_SELECTION: 'trips.kilometers.user-selection',
  TRIPS_EXPENSES_VIEW: 'trips.expenses.view',
  TRIPS_EXPENSES_EDIT: 'trips.expenses.edit',
  TRIPS_EXPENSES_USER_SELECTION: 'trips.expenses.user-selection',
  TEMPO_VIEW: 'tempo.view',
  TEMPO_EDIT: 'tempo.edit',
  TEMPO_USER_SELECTION: 'tempo.user-selection',
  ABSENCES_VIEW: 'absences.view',
  ABSENCES_EDIT: 'absences.edit',
  ABSENCES_USER_SELECTION: 'absences.user-selection',
  VIEW_ABSENCES_VIEW: 'view-absences.view',
  BUDGET_VIEW: 'budget.view',
  BUDGET_USER_SELECTION: 'budget.user-selection',
  ADMINISTRATION_BUDGET_VIEW: 'administration.budget.view',
  ADMINISTRATION_BUDGET_EDIT: 'administration.budget.edit',
  RETROSPECTIVE_GOALS_VIEW: 'retrospective-goals.view',
  RETROSPECTIVE_GOALS_USER_SELECTION: 'retrospective-goals.user-selection',
  RETROSPECTIVES_VIEW: 'retrospectives.view',
  RETROSPECTIVES_EDIT: 'retrospectives.edit',
  RETROSPECTIVE_GOAL_TYPES_VIEW: 'retrospective-goal-types.view',
  RETROSPECTIVE_GOAL_TYPES_EDIT: 'retrospective-goal-types.edit',
  EARNED_CERTIFICATIONS_VIEW: 'earned-certifications.view',
  EARNED_CERTIFICATIONS_EDIT: 'earned-certifications.edit',
  CERTIFICATIONS_VIEW: 'certifications.view',
  CERTIFICATIONS_EDIT: 'certifications.edit',
  PROJECTS_VIEW: 'projects.view',
  PROJECTS_EDIT: 'projects.edit',
  REPORT_VIEW: 'report.view',
  ADMINISTRATION_VIEW: 'administration.view',
  ADMINISTRATION_EDIT: 'administration.edit',
  PERMISSIONS_VIEW: 'permissions.view',
  PROFILE_VIEW: 'profile.view',
  PROFILE_EDIT: 'profile.edit',
};

// profile.view e profile.edit sono universali: ogni ruolo li ha perché
// la pagina /profile è accessibile a qualunque utente autenticato.
const PROFILE_PERMS = ['profile.view', 'profile.edit'];

export const ROLE_PERMISSIONS_MAP = {
  administration: [
    'trips.kilometers.view',
    'trips.kilometers.user-selection',
    'trips.expenses.view',
    'trips.expenses.user-selection',
    'tempo.view',
    'tempo.user-selection',
    'absences.user-selection',
    'administration.view',
    'administration.edit',
    'permissions.view',
    ...PROFILE_PERMS,
  ],
  budget_administration: [
    'budget.view',
    'budget.user-selection',
    'administration.budget.view',
    'administration.budget.edit',
    ...PROFILE_PERMS,
  ],
  certification_administration: [
    'earned-certifications.view',
    'earned-certifications.edit',
    'certifications.view',
    'certifications.edit',
    ...PROFILE_PERMS,
  ],
  data_analysis: ['report.view', ...PROFILE_PERMS],
  project_administration: ['projects.view', 'projects.edit', ...PROFILE_PERMS],
  retrospective_administration: [
    'retrospective-goals.view',
    'retrospective-goals.user-selection',
    'retrospectives.view',
    'retrospectives.edit',
    'retrospective-goal-types.view',
    'retrospective-goal-types.edit',
    ...PROFILE_PERMS,
  ],
  view_absences: ['view-absences.view', ...PROFILE_PERMS],
  view_earned_certifications: ['earned-certifications.view', ...PROFILE_PERMS],
  employees: [
    'trips.kilometers.view',
    'trips.kilometers.edit',
    'trips.expenses.view',
    'trips.expenses.edit',
    'tempo.view',
    'tempo.edit',
    'absences.view',
    'absences.edit',
    'budget.view',
    'retrospective-goals.view',
    ...PROFILE_PERMS,
  ],
};

export const REPORT_GROUP_BY = {
  NONE: 0,
  PROJECT: 1,
  ISSUE: 2,
};

export const EARNEDCERTIFICATIONS_GROUP_BY = {
  NONE: 0,
  CERTIFICATION: 1,
};

export const PROJECT_GROUP_BY = {
  NONE: 0,
  CUSTOMER: 1,
  PROJECT: 2,
  STATUS: 3,
};

export const USERS_PARAM_NAME = 'u';

export const DEFAULT_USER_WORKTIME = 8;
